module.exports = __webpack_public_path__ + "img/四川天府新区元音幼儿园.18ca45de.jpg";